var render = function render(){var _vm=this,_c=_vm._self._c;return _c('upload',{ref:"file_upload",attrs:{"id":_vm.id,"global":_vm.global},on:{"filesToUpload":_vm.filesToUpload,"uploaded":_vm.handleUpload}})
}
var staticRenderFns = []

export { render, staticRenderFns }